const doc = [({"en":({"activerecord":({"attributes":({"photo_session_csv":({"file":"File"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;